export const basic_icons = {
    addCircle: require("./addCircle.svg").default,
    addPerson: require("./addPerson.svg").default,
    arrowRight: require("./arrowRight.svg").default,
    arrowDown: require("./arrowDown.svg").default,
    arrowLeft: require("./arrowLeft.svg").default,
    arrowUp: require("./arrowUp.svg").default,
    bell: require("./bell.svg").default,
    book: require("./book.svg").default,
    calendar: require("./calendar.svg").default,
    camera: require("./camera.svg").default,
    change: require("./change.svg").default,
    check: require("./check.svg").default,
    checkCircle: require("./checkCircle.svg").default,
    circle: require("./circle.svg").default,
    clock: require("./clock.svg").default,
    dotHorizontal: require("./dotHorizontal.svg").default,
    dotHorizontalCircle: require("./dotHorizontalCircle.svg").default,
    dotsVertical: require("./dotsVertical.svg").default,
    dotsVerticalCircle: require("./dotsVerticalCircle.svg").default,
    download: require("./download.svg").default,
    eye: require("./eye.svg").default,
    eyeClosed: require("./eyeClosed.svg").default,
    graph: require("./graph.svg").default,
    hamburger: require("./hamburger.svg").default,
    image: require("./image.svg").default,
    info: require("./info.svg").default,
    inform: require("./inform.svg").default,
    login: require("./login.svg").default,
    logout: require("./logout.svg").default,
    microphone: require("./microphone.svg").default,
    minus: require("./minus.svg").default,
    minusCircle: require("./minusCircle.svg").default,
    modify: require("./modify.svg").default,
    office: require("./office.svg").default,
    onOff: require("./onOff.svg").default,
    onOffCircle: require("./onOffCircle.svg").default,
    people: require("./people.svg").default,
    person: require("./person.svg").default,
    play: require("./play.svg").default,
    plus: require("./plus.svg").default,
    question: require("./question.svg").default,
    removeCircle: require("./removeCircle.svg").default,
    search: require("./search.svg").default,
    setting: require("./setting.svg").default,
    smile: require("./smile.svg").default,
    trash_can: require("./trash can.svg").default,
    view: require("./view.svg").default,
    x: require("./x.svg").default,
};
